const gradients = [
  {
    name: "Sunrise Wash",
    className: "bg-kin-sunrise",
    purpose: "Default page background",
    intensity: "Low",
  },
  {
    name: "Wavy Cream",
    className: "bg-kin-waves",
    purpose: "Hero blocks and long sections",
    intensity: "Low-Mid",
  },
  {
    name: "Wavy Soft",
    className: "bg-kin-waves-soft",
    purpose: "Inset cards and utility panels",
    intensity: "Low",
  },
  {
    name: "Clouds",
    className: "bg-kin-clouds",
    purpose: "Navigation and quiet surfaces",
    intensity: "Low",
  },
  {
    name: "Splash",
    className: "bg-kin-splash",
    purpose: "Feature callouts and moments of energy",
    intensity: "Mid",
  },
];

function GradientCard({ gradient }) {
  return (
    <article className="kin-surface rounded-[20px] p-4">
      <div className={`h-36 rounded-[16px] border border-kin-olive/10 ${gradient.className}`} />
      <div className="mt-4">
        <p className="text-sm font-semibold text-kin-black">{gradient.name}</p>
        <p className="mt-1 text-xs text-kin-body/85">{gradient.purpose}</p>
        <div className="mt-3 flex items-center justify-between">
          <code className="rounded-full border border-kin-white/50 bg-kin-white/60 shadow-sm backdrop-blur-md px-3 py-1 text-[10px] text-kin-olive">
            {gradient.className}
          </code>
          <span className="text-[10px] font-semibold tracking-[0.12em] uppercase text-kin-muted">
            {gradient.intensity}
          </span>
        </div>
      </div>
    </article>
  );
}

export default function Gradients() {
  return (
    <section
      id="gradients"
      className="kin-section-glow border-t border-kin-olive/10 px-6 py-14 scroll-mt-16 sm:px-8 sm:py-16 gradient-wash"
    >
      <div className="mx-auto max-w-6xl">
        <p className="text-sm font-semibold tracking-[0.22em] uppercase text-kin-muted">
          09 - Gradients
        </p>

        <div className="mt-6 max-w-3xl">
          <h2 className="font-serif text-4xl font-bold text-kin-black sm:text-5xl">
            Atmospheric backgrounds
          </h2>
          <p className="mt-4 text-base leading-relaxed text-kin-body/90 sm:text-lg">
            Kin gradients add depth without visual noise. They should feel like ambient light, never
            decorative clutter.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {gradients.map((gradient) => (
            <GradientCard key={gradient.name} gradient={gradient} />
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-2">
          <article className="kin-surface-strong rounded-[24px] p-6">
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted">
              Application Rules
            </p>
            <ul className="mt-4 space-y-2 text-sm text-kin-body/90">
              <li>Use one dominant gradient per viewport for visual calm.</li>
              <li>Keep foreground contrast high; gradients are background context.</li>
              <li>Pair stronger gradients with simpler component compositions.</li>
              <li>Reserve Splash for focal features, not baseline screens.</li>
            </ul>
          </article>

          <article className="kin-surface-strong rounded-[24px] p-6">
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted">
              Sample Stack
            </p>
            <div className="mt-4 rounded-[20px] border border-kin-olive/10 p-4 bg-kin-sunrise">
              <div className="kin-surface rounded-[16px] p-4">
                <p className="text-xs font-semibold tracking-[0.12em] uppercase text-kin-muted">
                  Foreground Surface
                </p>
                <p className="mt-2 text-sm text-kin-body/90">
                  Elevated cards sit above ambient gradients with restrained blur and light edges.
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
